/**
 * Los inputs de límites se guardan como texto para que una celda vacía
 * represente inequívocamente "sin límite". Al enviar sólo conservamos montos
 * positivos y finitos: cero no es un tope útil y equivale a quitarlo.
 */
export function toCategoryLimitPayload(
  draft: Record<string, string>,
  allowedCategoryIds: readonly string[],
): Record<string, number> {
  const allowed = new Set(allowedCategoryIds);

  return Object.fromEntries(
    Object.entries(draft).flatMap(([categoryId, raw]) => {
      if (!allowed.has(categoryId) || raw.trim() === '') return [];

      const amount = Number(raw);
      return Number.isFinite(amount) && amount > 0 ? [[categoryId, amount]] : [];
    }),
  );
}

export function categoryLimitAllocation(
  limits: Record<string, number>,
  effectiveLimit: number,
): { allocated: number; remaining: number; isOverAllocated: boolean } {
  const allocated = Object.values(limits).reduce(
    (total, value) => total + (Number.isFinite(value) && value > 0 ? value : 0),
    0,
  );
  const remaining = effectiveLimit - allocated;

  return {
    allocated,
    remaining,
    // Igual que la API: tolera sólo el ruido binario de decimales, no un
    // centavo real por encima del límite.
    isOverAllocated: remaining < -0.000001,
  };
}
